export const zone = {
    path: '/operation/yiQingDistrict',
    name: 'BaseForm',
    component: () => import('../views/operation/yiQingDistrict'),
    meta: { title: '魔方专区', icon: 'dollar', isMenuShow: true, permission: 'opt:yiQingDistrict' },
}